import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import AllComponents from '../components';
import routesConfig from './config';
import queryString from 'query-string';
import axios from 'axios';
import { connectAlita } from 'redux-alita';
import { withTranslation } from 'react-i18next';

@withTranslation(['common'])
class CRouter extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.ajaxSetup();
    }

    componentWillMount() {

    }


    ajaxSetup = () => {
        axios.interceptors.response.use(
            response => {
                if (response.data.code === 100012) {// Login expired
                    console.log('Login expired: ', response.data);
                    localStorage.removeItem('user');
                    return <Redirect to={'/'} />;
                }
                return response;
            },
            error => {
                if (error.response) {
                    switch (error.response.status) {
                        case 401:

                            break;
                        default:
                            break;
                    }
                }
                return Promise.reject(error.response ? error.response.data : error)   // Return the error message returned by the interface
            })
    }

    requireLogin = (component, permission, r) => {
        const { auth, } = this.props;
        const data = auth.data;
        if (!data) {
            localStorage.removeItem('user');
            return <Redirect to={'/'} />;
        }
        return permission ? "" : component;
    };

    render() {
        const { allowedCodes } = this.props;
        console.log("🚀 ~ CRouter ~ render ~ allowedCodes :", allowedCodes)
        // Auto-complete allowedCodes, automatically add parent route code when sub-routes are included
        const addParentCodes = (menus, codes = new Set()) => {
            menus.forEach(menu => {
                if (menu.subs && menu.subs.length > 0) {
                    let hasAllowedSub = menu.subs.some(sub => codes.has(sub.code));
                    if (hasAllowedSub) {
                        codes.add(menu.code);
                    }
                    addParentCodes(menu.subs, codes);
                }
            });
            return codes;
        };
        // If allowedCodes is empty, all menu permissions are granted
        let allowedCodesSet;
        if (!allowedCodes || allowedCodes.length === 0) {
            allowedCodesSet = new Set();
            // Collect all codes
            const collectCodes = (menus) => {
                menus.forEach(menu => {
                    allowedCodesSet.add(menu.code);
                    if (menu.subs) collectCodes(menu.subs);
                });
            };
            collectCodes(routesConfig.menus);
        } else {
            allowedCodesSet = new Set(allowedCodes);
            allowedCodesSet = addParentCodes(routesConfig.menus, allowedCodesSet);
        }
        const allowedCodesWithParent = Array.from(allowedCodesSet);

        // Filter menus and routes
        const filterMenus = (menus) => {
            if (!allowedCodesWithParent) return menus;
            return menus.filter(menu => {
                if (menu.subs) {
                    menu.subs = filterMenus(menu.subs);
                }
                return allowedCodesWithParent.includes(menu.code);
            });
        };
        const filteredConfig = { ...routesConfig, menus: filterMenus(routesConfig.menus) };

        // Route access control
        const canAccessRoute = (code) => {
            if (!allowedCodesWithParent) return true;
            return allowedCodesWithParent.includes(code);
        };

        return (
            <Switch>
                {
                    Object.keys(filteredConfig).map(key =>
                        filteredConfig[key].map(r => {
                            const route = r => {
                                const Component = AllComponents[r.component];
                                return (
                                    <Route
                                        key={r.route || r.key}
                                        exact
                                        path={r.route || r.key}
                                        render={props => {
                                            // Route permission check
                                            if (r.code && !canAccessRoute(r.code)) {
                                                return <Redirect to="/404" />;
                                            }
                                            const reg = /\?\S*/g;
                                            const queryParams = window.location.hash.match(reg);
                                            const { params } = props.match;
                                            Object.keys(params).forEach(key => {
                                                params[key] = params[key] && params[key].replace(reg, '');
                                            });
                                            props.match.params = { ...params };
                                            const merge = { ...props, query: queryParams ? queryString.parse(queryParams[0]) : {} };
                                            const wrappedComponent = (
                                                <DocumentTitle title={this.props.t(r.title)}>
                                                    <Component {...merge} />
                                                </DocumentTitle>
                                            )
                                            return r.login
                                                ? wrappedComponent
                                                : this.requireLogin(wrappedComponent, r.auth, r)
                                        }}
                                    />
                                )
                            }
                            return r.component ? route(r) : r.subs.map(r => route(r));
                        })
                    )
                }
                <Route render={() => <Redirect to="/404" />} />
            </Switch>
        )
    }
}
export default withRouter(connectAlita(['auth', 'serverConfig', 'title'])(CRouter));
